module.exports = __webpack_public_path__ + "img/w3_circle_pause_grey.745d154e.png";